/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';

const Success = () => {
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.setItem("Paymentstatus", "PaymentDone");
        const path = secureLocalStorage.getItem("page");
        navigate(path);
    }, []);

    return null;
};

export default Success;

export const Cancel = () => {

    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.setItem("Paymentstatus", "Paymentfaild");
        const path = secureLocalStorage.getItem("page");
        navigate(path);
    }, []);

    return null;
};
/* jshint ignore:end */